import moment from 'moment';
export class AutomaticDiscountModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    get duration() {
        let formattedStartAt = '';
        let formattedEndAt = '';
        const startAt = this.startAt ? new Date(this.startAt) : null;
        const endAt = this.endAt ? new Date(this.endAt) : null;
        formattedStartAt = startAt ? moment(startAt).format('MMM D, Y') : '';
        formattedEndAt = endAt ? moment(endAt).format('MMM D, Y') : '';
        return `${formattedStartAt} - ${formattedEndAt}`;
    }
}
